import React from 'react';
import { Box, Typography } from '@mui/material';
import { herosubtitle, herotitle, heroImageSrc } from './HeroConst';

const Hero = () => {
  return (
    <Box
      sx={{
        mt: { xs: 3, sm: 4, md: 5 },
        bgcolor: 'background.default',
        pt: 6,
        pb: 4,
        textAlign: 'center',
      }}
      mx="auto"
    >
      <Box maxWidth={{ xs: 343, sm: 792 }} mx="auto">
        <Typography
          sx={{
            fontWeight: '700',
            fontSize: { xs: '32px', md: '46px' },
            lineHeight: { xs: '38.4px', md: '61.44px' },
            fontFamily: 'sans-serif',
          }}
          gutterBottom
        >
          {herotitle}
        </Typography>
        {/* Subtitle */}
        <Typography
          sx={{
            fontWeight: '400',
            fontSize: { xs: '14px', md: '16px' },
            lineHeight: { xs: '22.4px', md: '28.8px' },
            textWrap: 'pretty',
            textAlign: 'center',
            fontFamily: 'sans-serif',
          }}
          color="#727272"
          mb={{ xs: 2, sm: 4 }}
        >
          {herosubtitle}
        </Typography>
      </Box>

      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          width: { xs: '95%', sm: '100%' },
          margin: '0 auto',
        }}
      >
        <Box
          component="img"
          sx={{
            borderRadius: 4,
            maxWidth: { xs: 343, sm: 800, lg: 1000 },
            minHeight: { xs: 191, md: 500 },
          }}
          src={heroImageSrc}
          alt="Team collaboration"
        />
      </Box>
    </Box>
  );
};

export default Hero;
